import { ReactElement } from 'react';

type Props = {
  subscriptionStatus: string,
};

function SubscriptionStatus({ subscriptionStatus }: Props): ReactElement {
  return (
    <>
      <div id="subscription-status" className="c-subscription-management-option is-disabled">
        <div className="c-subscription-management-option__content">
          <h3 className="c-heading c-heading--brand-6">
            Your subscription is&nbsp;
            <span className="badge badge-pill">
              {subscriptionStatus}
            </span>
          </h3>
        </div>
      </div>
    </>
  );
}

export default SubscriptionStatus;
